import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isPdfUrl',
  standalone: true,
  pure: true
})
export class IsPdfUrlPipe implements PipeTransform {

  transform(url: string): boolean {
    if (!url) {return false;}
    try {
      const pathname = new URL(url).pathname.toLowerCase();
      return pathname.endsWith('.pdf');
    } catch {
      return false;
    }
  }
}
